/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_tariffsearch.js                                                                     */
/**********************************************************************************************************************/
/* Controller.TariffSearch */

/**
 * @class this.Controller.TariffSearch
 */
HafasWebapp.prototype.Controller.TariffSearch = {
  /**
   * @class this.Controller.TariffSearch.index
   *
   * @param data
   */
  showTimeInGui: false,
  currentView: null,
  tariffSelectBoxes: [],
  locationsForValidation: ["From","To"],
  tariffFilter: {
    usageL: "ONEWAY",
    classL: "SECOND",
    cardL: "NONE",
    typePersL: "ADULT"
  },
  currentForm: null,    // um außerhalb von postForm eine Referenz auf das Formular zu haben; wird in renderIndex gesetzt
  index: function () {
    Hafas.Modules.Loader.loadTemplateFiles(['tariffsearch.index.html', 'tariffsearch.form.input.html'], Hafas.bind(function () {
      Hafas.bind(this.Controller.TariffSearch.renderIndex, this)();
    }, this));
  },
  createIndexModel: function () {
    var model = {};
    return model;
  },
  renderIndex: function () {
    var controller = this.Controller.TariffSearch;
    this.Controller.TariffSearch.cleanup();

    var model = Hafas.bind(this.Controller.TariffSearch.createIndexModel, this)();

    if (Hafas.Modules.History)
      Hafas.Modules.History.addData("TariffSearch", "index", {});

    var me = this;

    if (Hafas.Config.debug.showDataModel) {
      console.log('+++ TariffSearch.index +++ DEBUG Model +++', model)
    }

    var formContainer = Hafas("#" + me.formContainer);
    formContainer.innerHTML = Hafas.Modules.Render.renderTemplate("TariffSearch_TplIndex", model);
    me.Controller.TariffSearch.currentForm = Hafas('#HFS_FormTariffSearch', false, formContainer);

    if(this.Controller.TariffSearch["hideInput_From"] !== undefined){
      Hafas.Util.gui.setVisibility(Hafas('#HFS_TariffSearchInputFromWrap', false), false);
      Hafas('#TariffSearch_From',false).removeAttribute("required");
    }
    if(this.Controller.TariffSearch["hideInput_To"] !== undefined){
      Hafas.Util.gui.setVisibility(Hafas('#HFS_TariffSearchInputToWrap', false), false);
      Hafas('#TariffSearch_To',false).removeAttribute("required");
    }

    var baseConfigTariffSearch = {};
    baseConfigTariffSearch.useNearLocation = false;
    baseConfigTariffSearch.useChooseFromMap = false;
    baseConfigTariffSearch.useHistoryLocations = 'NONE';

    me.Controller.TariffSearch.inpFrom = Hafas.Core.newType('hafasSuggest', {
      loc: "TariffSearch_From",
      config: baseConfigTariffSearch,
      type: "S",
      onSelect: function (loc) {
        Hafas.bind(me.Controller.TariffSearch.validateSelection, me)('dep', loc);
      },
      onClear: function () {
        Hafas.ps.pub('/map/clearLocationMarker', ["dep"]);
      }
    });

    me.Controller.TariffSearch.inpTo = Hafas.Core.newType('hafasSuggest', {
      loc: "TariffSearch_To",
      config: baseConfigTariffSearch,
      type: "Z",
      onSelect: function (loc) {
        Hafas.bind(me.Controller.TariffSearch.validateSelection, me)('arr', loc);
      },
      onClear: function () {
        Hafas.ps.pub('/map/clearLocationMarker', ["arr"]);
      }
    });

    var tmpLoc = me.Controller.TariffSearch.instance.getLocation("dep");
    if (tmpLoc != null) {
      me.Controller.TariffSearch.inpFrom.setLocation(tmpLoc);
    }

    tmpLoc = me.Controller.TariffSearch.instance.getLocation("arr");
    if (tmpLoc != null) {
      me.Controller.TariffSearch.inpTo.setLocation(tmpLoc);
    }


    // setting tdp-configuration
    var dateTimePickerConfig = {
      holder: "HFS_TariffSearchDateTimePickerHolder",
      id: "TariffSearchDTP",
      config: {
        useDepArrSwitch: false,
        useTimePicker: false
      },
      current: {
        date: me.Controller.TariffSearch.instance.getTravelDate(),
        time: '000000',
        enquiry: false,
        isNowMode: me.Controller.TariffSearch.instance.getTimeNow()
      }
    };

    if(me.Controller.TariffSearch.firstDateBorder !== undefined){
      dateTimePickerConfig.config.firstDateBorder = me.Controller.TariffSearch.firstDateBorder;
    }

    if(me.Controller.TariffSearch.lastDateBorder !== undefined){
      dateTimePickerConfig.config.lastDateBorder = me.Controller.TariffSearch.lastDateBorder;
    }

    me.Controller.TariffSearch.dateTimePicker = Hafas.Core.newType('hafasTimeDatePicker', dateTimePickerConfig);
    me.Controller.TariffSearch.currentView = "index";


    Hafas.ps.pub('/app/events/renderDone');


    // f?lle die UIActions des TariffSearch-Moduls
    // TariffSearch_TplFormUIActions
    if (Hafas("#" + me.formUIHiddenActions)) {
      Hafas("#" + me.formUIHiddenActions).innerHTML = Hafas.Modules.Render.renderTemplate("Common_TplFormUIActions", {appcontext: 'TariffSearch'});
    }

    // Tracking (TBD)
    // Hafas.ps.pub('/tracking/screen/journey-planner-main', [ { typ: 'screen', key: 'journey-planner-main' } ]);
    // Hafas.ps.pub('/tracking/screen/tripplanner-main', [ { typ: 'screen', key: 'tripplanner-main' } ]);

    Hafas.ps.pub('/GUI/form/show', [{}]);
    Hafas.ps.pub('/app/events/resize');
    Hafas.ps.pub('/app/contextLoaded/' + me.appContext);

    Hafas.Util.gui.focusTabOrMenuButton();
  },
  hideInputField: function (type) {
    var inputFieldContainer = Hafas('#HFS_TariffSearchInput' + type + 'Wrap', false);
    this.Controller.TariffSearch["hideInput_" + type] = true;
    Hafas.Util.gui.setVisibility(inputFieldContainer, false);
    Hafas('#TariffSearch_' + type,false).removeAttribute("required");
  },
  hideDate: function () {
    Hafas.Util.gui.setVisibility(Hafas('#HFS_TariffSearchDateTimePickerWrap'), false);
  },
  showTime: function (boolval){
    this.Controller.TariffSearch.showTimeInGui = boolval;
    this.Controller.TariffSearch.dateTimePicker.setUseTimePicker(boolval);
  },
  getDateWithOffset: function(offset){
    var serverHciDate = Hafas.Core.newType("hafasTime", {date: Hafas.Config.serverDate });
    var jsDate = serverHciDate.getJsDate();
    jsDate.setDate(jsDate.getDate()+offset);
    var offsetDate = Hafas.Core.newType("hafasTime", {jsDate: jsDate });
    return offsetDate.getHCIDate();
  },
  setDateOffsetMin: function(offset){
    var offsetDate = this.Controller.TariffSearch.getDateWithOffset(offset);
    this.Controller.TariffSearch.firstDateBorder = offsetDate;
    this.Controller.TariffSearch.dateTimePicker.setFirstDateBorder(offsetDate);
  },
  setDateOffsetMax: function(offset){
    var offsetDate = this.Controller.TariffSearch.getDateWithOffset(offset);
    this.Controller.TariffSearch.lastDateBorder = offsetDate;
    this.Controller.TariffSearch.dateTimePicker.setLastDateBorder(offsetDate);
  },
  setMetaFilter: function (type, metaFltr) {
    this.Controller.TariffSearch["inp" + type].setLocationFilter({"type": "META", "mode": "INC", "value": metaFltr});
  },
  setTariffContext: function (ctx) {
    this.Controller.TariffSearch.instance.setTariffContext(ctx);
  },
  validateSelection: function (type, loc) {
    // location setzen
    this.Controller.TariffSearch.instance.setLocation(type, loc);

    if (type == 'dep') {
      // form validieren
      this.Controller.TariffSearch.validate(['From'], Hafas.bind(function () {
        Hafas.Core.newType("hafasValidation", {
          form: this.Controller.TariffSearch.currentForm
        });
      }, this));
    } else if (type == 'arr') {
      // form validieren
      this.Controller.TariffSearch.validate(['To'], Hafas.bind(function () {
        Hafas.Core.newType("hafasValidation", {
          form: this.Controller.TariffSearch.currentForm
        });
      }, this));
    }
  },
  validate: function (items, callback) {
    var tariffSearchController = this.main.Controller.TariffSearch;
    var resolvedCount = 0;
    var itemLength = items.length;

    // Increments the counter, firing the callback when all items are resolved
    function resolveMe() {
      resolvedCount++;
      if (resolvedCount === itemLength) {
        callback();
      }
    }

    for (var i = 0; i < itemLength; i++) {
      var itemId = items[i];
      var locationId;

      switch (itemId) {
        case 'From':
          locationId = 'dep';
          break;
        case 'To':
          locationId = 'arr';
          break;
        default:
          resolveMe();
          continue;
      }

      var location = tariffSearchController.instance.getLocation(locationId);
      var input = tariffSearchController['inp' + itemId];
      var inputText = input.getInputText();

      // location and inputtext aren't synchronized.
      if(!location && inputText) {
        location = {name:inputText};
      }

      // Location is valid -> resolve
      if (Hafas.Util.location.isValid(location) && Hafas.Util.getLocationAttribute(location,'name') === inputText) {
        resolveMe();
      } else {
        // Something is missing in location -> validate -> LocMatch -> resolve
        if(Object.keys(location).length > 0) {
          input.validateLocation(true, resolveMe);
        } else {
          // Empty Location -> resolve -> show error (see validateQueryLocations)
          resolveMe();
        }
      }
    }
  },
  postForm: function (data) {
    var _me = this;

    if (typeof data.ev != 'undefined')
      data.ev.preventDefault();

    //Wird die Suche durch extere Parameter gestartet.
    data.searchFromExternal = !!data.searchFromExternal;

    // close all additional resultcontainer
    Hafas.ps.pub('/GUI/results/additional/hideAll');


    try {
      var validateCallback = Hafas.bind(function (forceSubmit) {
        var form = Hafas.Core.newType("hafasValidation", {
          form: data.form
        });
        // If input are valid -> proceed with connection search
        if (form.valid || forceSubmit) {
          // show loadingImage and set Button to disabled
          if (data.form.elements.submitTariffSearchForm) {
            Hafas.bind(this.Controller.App.triggerLoadingImage, this)(data.form.elements.submitTariffSearchForm);
          }

          // Search tariffs
          this.Controller.TariffSearch.instance.search({
            callback: Hafas.bind(this.Controller.TariffSearch.showResultOverview, this)
          });


          // Track
          Hafas.ps.pub('/tracking/event/connection-request', ['[' + _me.appContext + '] SEARCH: ' + data.form.elements.TariffSearch_From.value + ' --> ' + data.form.elements.TariffSearch_To.value]);

          if (data.searchFromExternal) {
            Hafas.bind(this.Controller.TariffSearch.showWaitView, this)(Hafas.Modules.i18n.get('TP.index.t_N_WaitSearchConnection'));
          }

        }
      }, this);

        var locsToProcess = Hafas.Core.clone(this.Controller.TariffSearch.locationsForValidation);
        var locsToValidate = [];
        for(var l = 0 ; l < locsToProcess.length;l++){
          if(this.Controller.TariffSearch["hideInput_" + locsToProcess[l]] !== undefined) {
            locsToValidate = locsToProcess.filter(function (item) {
              return item !== locsToProcess[l]
            });
          }
        }

        // Wenn bedingt durch ausblenden keine Felder mehr validiert werden müssen, so kann direkt in den Callback gesprungen werden
        if(locsToValidate.length == 0) {
          validateCallback(true);
        }else {
          // Ansonsten wie gehabt Validierung der relevanten Eingabefelder
          this.Controller.TariffSearch.validate(locsToValidate, validateCallback);
        }

      if (!Hafas.Config.UI.showOptionsOnInit) {
        Hafas.ps.pub('/GUI/tabs/closeAll');
        Hafas.ps.pub('/GUI/options/closeAll');
      }
      Hafas.ps.pub('/app/events/resize');
    } catch (e) {
      console.log(e);
    }
    return false;
  },
  selectDateTimeFromPicker: function (hciDate, hciTime, enquiry, setTimeNow) {
    this.Controller.TariffSearch.instance.setTravelDate(hciDate);
    if(this.Controller.TariffSearch.showTimeInGui) {
      this.Controller.TariffSearch.instance.setTravelTime(hciTime);
    }
    this.Controller.TariffSearch.instance.setTimeNow(setTimeNow);

  },
  chooseVariant: function (ctx) {
    if (ctx.length > 0) {
      this.Controller.TariffSearch.instance.searchByCtx(ctx);
    }
  },
  showResultOverview: function (data) {
    Hafas.Modules.History.addOrUpdateData("TariffSearch", "overview", data);

    if (!Hafas.Config.showFormOnResult) {
      Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'TariffSearch'}]);
    }

    var filterInfo = Hafas.Util.Tariffs.resolveFilterProperties(data.fareSetL);
    this.Controller.TariffSearch.filterInfo = filterInfo;

    // FareSets alle initial anzeigen
    for (var d = 0; d < data.fareSetL.length; d++) {
      data.fareSetL[d].showInitially = true;
    }

    var model = {
      tariffInfoBox: {
        fareSetListResolved: data.fareSetL
      },
      showFilter: filterInfo.filterFound,
      filter: Hafas.Util.Tariffs.getDefaultTariffFilter(this.Controller.TariffSearch.tariffFilter, filterInfo.foundFilters, 'tariffsearch'),
      ctx: 'tariffsearch'
    };
    if (typeof data.variantL != 'undefined') {
      model.variantList = data.variantL;
    } else {
      model.variantList = [];
    }
    model.viewHeader = {
      overview: Hafas.Modules.i18n.get('TariffSearch.index.t_N_Overview')
    };

    Hafas.ps.pub('/GUI/results/overview/show', [{}]);

    // is defined in classic-Version GUI-Functions
    Hafas.ps.pub('/GUI/window/scrollTo', ['top']);

    this.Controller.TariffSearch.currentView = "overview";

    var focusSelector = Hafas.Util.gui.getFocusElementSelector();

    Hafas.Modules.Loader.loadTemplateFiles(['tariffs.index.html', 'tp.result.detail.html'], Hafas.bind(function () {
      Hafas.Modules.Render.render({
        file: 'tariffsearch.result.overview.html',
        target: 'TariffSearch_ResultOverview',
        template: 'TariffSearch_TplOverview',
        model: model
      }, Hafas.bind(function () {

        if (model.variantList.length > 0) {
          var tmpSelectBox = Hafas.Core.newType('HafasSelectBox', {
            holder: 'HFS_TariffSearchVariantList_Holder', callback: function (data) {
              Hafas.ps.pub('/tariffsearch/chooseVariant', [decodeURIComponent(data.value)]);
            }
          });
          tmpSelectBox.initiate();
          this.Controller.TariffSearch.tariffSelectBoxes.push(tmpSelectBox);
        }

        if (filterInfo.filterFound) {
          Hafas.bind(this.Controller.TariffSearch.updateTariffFilterResults, this)(filterInfo.foundFilters);
        }

        Hafas.ps.pub('/GUI/results/resize', [{container: this.resultOverviewContainer, appcontext: this.appContext}]);
        Hafas.ps.pub('/app/events/resize');

        if (!focusSelector || focusSelector.indexOf('#HFS_TariffSearchVariantList') === -1) {
          // Focus first element if we dont have a focusSelector or the focusSelector does not contain the route dropdown ID
          focusSelector = Hafas.Util.node.getPath(Hafas.Util.node.getFirstVisibleAndFocusableElement(Hafas('#HFS_DocumentResultOverview')));
        }
        Hafas.Util.gui.restoreFocus(focusSelector);
      }, this));
    }, this));
  },
  showErrorPage: function (data) {
    if (!Hafas.Config.showFormOnResult) {
      Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'TariffSearch'}]);
    }

    Hafas.Modules.History.addOrUpdateData("TariffSearch", "error", data);

    Hafas.ps.pub('/GUI/results/overview/show', [{}]);

    var model = {};
    model.viewHeader = {
      overview: Hafas.Modules.i18n.get('TariffSearch.index.t_N_Overview')
    };
    model.statusText = data.statusText;

    this.Controller.TariffSearch.currentView = "overview";

    Hafas.Modules.Render.render({
      file: 'tariffsearch.result.overview.html',
      target: 'TariffSearch_ResultOverview',
      template: 'TariffSearch_ErrorTpl',
      model: model
    }, Hafas.bind(function () {

      Hafas.ps.pub('/GUI/results/resize', [{container: this.resultOverviewContainer, appcontext: this.appContext}]);
      Hafas.ps.pub('/app/events/resize');
    }, this));
  },
  updateTariffOverview: function (data) {
    this.Controller.TariffSearch.tariffFilter[data.key] = data.value;
    if (typeof this.Controller.TariffSearch.filterInfo != 'undefined') {
      Hafas.bind(this.Controller.TariffSearch.updateTariffFilterResults, this)(this.Controller.TariffSearch.filterInfo.foundFilters);
    } else {
      Hafas.bind(this.Controller.TariffSearch.updateTariffFilterResults, this)();
    }
  },
  updateTariffFilterResults: function (usedFilters) {
    var allFareSets = Hafas('[data-contid="TariffSearch"] .lyr_tariffFaresetItemWrapper', true);
    var visibleFaresets = 0;
    for (var a = 0; a < allFareSets.length; a++) {
      var allFSItems = Hafas('[data-tariff-fareset="item"]', true, allFareSets[a]);
      var visElems = false;
      allFSItems.forEach(Hafas.bind(function (elem) {
        var visStatus = Hafas.Util.Tariffs.resolveVisibility(elem, this.Controller.TariffSearch.tariffFilter);
        if (visStatus) {
          visElems = true;
        }
        Hafas.Util.gui.setVisibility(elem, visStatus);
      }, this));

      var queryString = '';
      for (var t in this.Controller.TariffSearch.tariffFilter) {
        queryString += '[data-' + t.toLowerCase() + '=' + this.Controller.TariffSearch.tariffFilter[t] + ']';
      }

      // Wenn Filter dazu führt, dass nix angezeigt wird
      var noResults = Hafas('[data-tariff-noresults="filter"]', false, allFareSets[a]);

      var fareSetContainer = Hafas('[data-tariff-fareset="' + a + '"]', false);
      if (!visElems) {
        Hafas.Util.gui.setVisibility(noResults, true);
        Hafas.Util.gui.setVisibility(fareSetContainer, false);
      } else {
        Hafas.Util.gui.setVisibility(noResults, false);
        Hafas.Util.gui.setVisibility(fareSetContainer, true);
        visibleFaresets++;
      }
    }
    // Wenn gar keine Ergebnisse in den Faresets gefunden worden sind, dann allgemeine Fehlermeldung einblenden
    var fareSetWrapper = Hafas('[data-tariff-wrapper="fareset"]', false);
    var tariffNotFoundContainer = Hafas('[data-tariff-wrapper="errorNotFound"]', false);
    if (visibleFaresets == 0) {
      Hafas.Util.gui.setVisibility(fareSetWrapper, false);
      Hafas.Util.gui.setVisibility(tariffNotFoundContainer, true);
    } else {
      Hafas.Util.gui.setVisibility(fareSetWrapper, true);
      Hafas.Util.gui.setVisibility(tariffNotFoundContainer, false);
    }
    Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('common.label.t_N_LoadingEnds'));
    Hafas.ps.pub('/app/events/resize');
  },
  toggleFareSet: function (idx, boolval) {
    var faresetToToggle = Hafas('[data-tariff-fareset-id="' + idx + '"]', false);
    Hafas.Util.gui.setVisibility(faresetToToggle, boolval);
  },
  switchFromTo: function () {
    this.Controller.TariffSearch.instance.switchLocations();
  },
  setGeoLocationPosition: function (locObj, inputId) {
    if (inputId == "TariffSearch_From")
      this.Controller.TariffSearch.instance.setLocation('dep', locObj);
  },
  closeView: function (histData) {
    // console.log("+++ close view +++", histData);
    switch (histData.view) {
      case "index":
        Hafas.ps.pub('/GUI/form/hide', [{}]);
        break;
      case "overview":
        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        break;
      case "details":
        Hafas.ps.pub('/GUI/results/details/hide', [{}]);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/hide', []);
        break;
    }

  },
  restoreView: function (histData) {
    // console.log("+++ restore view +++", histData);
    var view = histData.view;
    switch (view) {
      case "index":
        Hafas.bind(this.Controller.TariffSearch.renderIndex, this)(histData.data);
        break;
      case "overview":
        Hafas.bind(this.Controller.TariffSearch.showResultOverview, this)(histData.data);
        break;
      case "details":
        if (this.Controller.Map.instance) {
          this.Controller.Map.hideConnection();
        }
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/show', [{template: 'Common_MapPageHeaderDefault'}]);
        break;
      case "tariffInfoBoxGroup":
        Hafas.bind(this.Controller.TP.renderTariffInfoBoxGroups, this)(histData.data, {});
        break;
    }
  },
  /**
   * removes map content (that has been created in the tariff search context)
   *
   * @method clearMap
   */
  clearMap: function () {
    if (typeof this.Controller.Map != 'undefined') {
      this.Controller.Map.hideConnection();
      this.Controller.Map.hideTripMarker();
    }
  },
  cleanup: function () {
    Hafas('#TariffSearch_ResultOverview', false).innerHTML = '';

    Hafas.ps.pub('/options/gui/close/groups', [{}]);
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    Hafas.ps.pub('/GUI/results/details/hide', [{}]);
    Hafas.ps.pub('/GUI/form/hide', [{}]);
  },

  /**
   * clears all input data (including options)
   *
   * @method
   */
  clearInput: function () {
    // Entferne aktuellen History-Eintrag, da nachfolgend über switchContext ein neuer hinzu kommt
    Hafas.Modules.History.removeCurrentStep("index", () => {
      Hafas.ps.pub('/app/switchContext', [{context: 'TariffSearch', method: 'index'}]);
    });

    var me = this;
    me.Controller.TariffSearch.instance.setLocation("dep", null);
    me.Controller.TariffSearch.instance.setLocation("arr", null);
    me.Controller.TariffSearch.dateTimePicker.setTimeNowOn();

    me.Controller.TariffSearch.inpFrom.resetLocation();
    me.Controller.TariffSearch.inpTo.resetLocation();

    Hafas.Modules.a11y.Announce.assertive(Hafas.Modules.i18n.get('common.menu.t_N_clearInput_success'));
  }
};
